import React from 'react';
import AppWrapper from 'components/Layout/AppWrapper';
import { IEntity } from 'interfaces/entity';
import { IAppRoute } from 'interfaces/route';
import { IUserToken } from 'interfaces/userToken';
import { PureComponent } from 'react';
import { combineLatest } from 'rxjs';
import RxOp, { ICacheResult } from 'rxjs-operators';
import authService from 'services/auth';
import entityService from 'services/entity';
import selectedVentureService, { ISelection } from 'services/profile';

import Entity from './Entity';
import EntityRouter from './entityRouter';
import Router from './router';

interface IState {
  routes: IAppRoute[];
}

export default class AdminModule extends PureComponent<{}, IState>  {
  static routes: IAppRoute[] = Router.routes;

  constructor(props: {}) {
    super(props);
    this.state = { routes: [] };
  }

  componentDidMount() {
    this.loadData();
  }

  updateRoutes = (user: IUserToken, selectedVenture: ISelection) => {
    const routes = Router.routes
      .filter(route => user.canAccess(...route.roles))
      .filter(route => !(route.isProfileSelectedDependent && !selectedVenture));
    this.setState({ routes });
    AdminModule.routes = routes;
  }

  loadData = () => {
    combineLatest([
      authService.getUser(),
      selectedVentureService.getSelectedVenture()
    ])
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(value => {
        const [user, selectedVenture] = value;
        if (!user) {
          this.setState({ routes: [] });
          return;
        }
        entityService
          .fetchEntitiesGraph(
            selectedVenture ? selectedVenture.id : (user.ventures[0] && user.ventures[0].id)
          )
          .pipe(RxOp.logError(), RxOp.bindComponent(this))
          .subscribe(entitiesGraph => {
            const entityRoutes = selectedVenture
              ? this.getEntityRouterRoutes(entitiesGraph, selectedVenture.id)
              : [];
            EntityRouter.routes = entityRoutes;
            this.updateRoutes(user, selectedVenture);
          });
        this.updateRoutes(user, selectedVenture);
      });
  }

  getEntityRouterRoutes(entitiesGraph: ICacheResult<IEntity[]>, selectedVentureId: number): IAppRoute[] {
    return entitiesGraph.data ?
      entitiesGraph.data
        .filter(entity => entity.parentId === null && (entity.ventureId === selectedVentureId || entity.ventureId === null))
        .sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
        .sort((a, b) => {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        })
        .map(entity => ({
          path: `/venture/${selectedVentureId}/entity/${entity.id}`,
          sideDrawer: { display: entity.name },
          component: Entity,
        })) as IAppRoute[] : [];
  }

  render() {
    const { routes } = this.state;

    return (
      <AppWrapper routes={routes}>
        {this.props.children}
      </AppWrapper>
    );
  }
}
